import type { Author } from "@/content/authors";
import { User } from "lucide-react";

const AuthorByline = ({ author, lastUpdated }: { author: Author; lastUpdated: string }) => (
  <div className="flex items-center gap-3 text-sm text-foreground/70">
    <div className="w-10 h-10 rounded-full bg-primary/10 border border-primary/20 flex items-center justify-center text-primary">
      <User className="w-5 h-5" />
    </div>
    <div>
      <div className="font-medium text-foreground">{author.name}</div>
      <div className="text-xs">
        {author.role} · Updated{" "}
        <time dateTime={lastUpdated}>
          {new Date(lastUpdated).toLocaleDateString("en-GB", {
            day: "numeric",
            month: "long",
            year: "numeric",
          })}
        </time>
      </div>
    </div>
  </div>
);

export default AuthorByline;
